import React from 'react';

const getRuleTypeLabel = (ruleType) => {
  const types = {
    'STRING_MANIPULATION': 'String Manipulation',
    'CONDITIONAL': 'Conditional Logic',
    'LOOKUP': 'Reference Data Lookup'
  };
  return types[ruleType] || ruleType;
};

const RuleSelectionPanel = ({
  rules,
  selectedRuleIds,
  selectedCustomerId,
  onRuleToggle,
  onSelectAll,
  isAllSelected,
}) => {
  if (!selectedCustomerId) {
    return (
      <div className="alert alert-info mb-0">
        Please select a customer to view available rules
      </div>
    );
  }

  if (rules.length === 0) {
    return (
      <div className="alert alert-warning mb-0">
        No active rules found for this customer
      </div>
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <label className="form-label mb-0">
          <strong>Rules to Test</strong> <span className="text-danger">*</span>
        </label>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onSelectAll}
        >
          {isAllSelected ? 'Deselect All' : 'Select All'}
        </button>
      </div>
      
      <div style={{ 
        maxHeight: '300px', 
        overflowY: 'auto', 
        border: '1px solid #dee2e6', 
        borderRadius: '4px',
        padding: '10px',
        backgroundColor: 'white'
      }}>
        {rules.map(rule => (
          <div key={rule.id} className="form-check mb-2">
            <input
              type="checkbox"
              id={`rule-${rule.id}`}
              className="form-check-input"
              checked={selectedRuleIds.includes(rule.id)}
              onChange={() => onRuleToggle(rule.id)}
            />
            <label htmlFor={`rule-${rule.id}`} className="form-check-label">
              <strong>{rule.name}</strong>
              <span className="badge bg-secondary ms-2">{rule.executionOrder}</span>
              <span className="badge bg-info ms-2">{getRuleTypeLabel(rule.ruleType)}</span>
              {rule.description && (
                <div style={{ fontSize: '0.85em', color: '#666', marginTop: '4px' }}>
                  {rule.description}
                </div>
              )}
            </label>
          </div>
        ))}
      </div>
    </>
  );
};

export default RuleSelectionPanel;
